import { createEffect, createEvent, createStore } from 'effector'
import { VOUCHER_API } from '../api/voucher'

export const voucherActions = {
  update: createEvent('update voucher'),
  reset: createEvent('reset voucher'),
}

export const fetchVoucher = createEffect('fetchVoucher', {
  async handler({ voucherCode, email, captchaToken }) {
    return await VOUCHER_API.fetch(voucherCode, email, captchaToken)
  },
})

export const voucherStore = createStore(null)
  .on(voucherActions.update, (state, newState) => Object.assign({}, newState))
  .on(fetchVoucher.doneData, (state, newState) => Object.assign({}, newState))
  .reset(voucherActions.reset)
